<!--
 * @Description: 学生学籍异动记录 详情
 * @Author: ZSC
 * @Date: 2023-04-20 11:28:35.792
 * @LastEditors: PF
 * @LastEditTime: 2026-09-30 09:28:37
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="学生" label-align="right" align="left" width="120px" span="2">{{ruleForm.xm}}（{{ ruleForm.xh }}）</el-descriptions-item>
        <el-descriptions-item label="异动类别" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in ydlxData.list" :key="index">
            <span v-if="ruleForm.ydlb == item.value">{{ item.label }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="异动日期" label-align="right" align="left" span="2">{{ruleForm.ydrq}}</el-descriptions-item>
        <el-descriptions-item label="异动原因" label-align="right" align="left" span="2">{{ruleForm.ydyybt}}</el-descriptions-item>
        <el-descriptions-item label="审批日期" label-align="right" align="left" span="2">{{ruleForm.sprq}}</el-descriptions-item>
        <el-descriptions-item label="审批文号" label-align="right" align="left" span="2">{{ruleForm.spwh}}</el-descriptions-item>
        <el-descriptions-item label="经办人" label-align="right" align="left" span="2">{{ruleForm.jbrxm}}</el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" span="2">
          <span v-if="ruleForm.zt == 0">已录入</span>
          <span v-if="ruleForm.zt == 1">已提交</span>
          <span v-if="ruleForm.zt == 9">审批通过</span>
          <span v-if="ruleForm.zt == 10">拒绝</span>
          <span v-if="ruleForm.zt == 20">生效</span>
          <span v-if="ruleForm.zt == 21">已销假</span>
        </el-descriptions-item>
        <!-- <el-descriptions-item label="审批后状态" label-align="right" align="left" span="2" v-if="ruleForm.ydlb === 99">{{ruleForm.sphzt}}</el-descriptions-item> -->
        <el-descriptions-item label="异动来源学校" label-align="right" align="left" span="4" v-if="isLeaveOut">{{ruleForm.ydlyxx}}</el-descriptions-item>
        <el-descriptions-item label="异动去向学校" label-align="right" align="left" span="4" v-if="isLeaveOut">{{ruleForm.ydqxxx}}</el-descriptions-item>
        <el-descriptions-item label="异动说明" label-align="right" align="left" span="4">{{ruleForm.ydsm}}</el-descriptions-item>
        <el-descriptions-item label="原专业" label-align="right" align="left" span="2" v-if="isLevelChange">{{ruleForm.yzymc}}</el-descriptions-item>
        <el-descriptions-item label="现专业" label-align="right" align="left" span="2" v-if="isLevelChange">{{ruleForm.xzymc}}</el-descriptions-item>
        <el-descriptions-item label="原班级" label-align="right" align="left" span="2" v-if="isLevelChange">{{ruleForm.ybjmc}}</el-descriptions-item>
        <el-descriptions-item label="现班级" label-align="right" align="left" span="2" v-if="isLevelChange">{{ruleForm.xbjmc}}</el-descriptions-item>
        <el-descriptions-item label="原年级" label-align="right" align="left" span="2" v-if="isLevelChange">{{ruleForm.ynjmc}}</el-descriptions-item>
        <el-descriptions-item label="现年级" label-align="right" align="left" span="2" v-if="isLevelChange">{{ruleForm.xnjmc}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, computed } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'
import { getXjydlx } from '@/utils/meiju'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

const ydlxData = ref(getXjydlx()) // 学籍异动类型

// 学业层级变动类异动
const LEVEL_CHANGE_TYPES = [
  ydlxData.value.liuJi,
  ydlxData.value.jiangJi,
  ydlxData.value.tiaoJi,
  ydlxData.value.shiDu,
  ydlxData.value.huiGuoFuXue,
  ydlxData.value.fuXue,
  ydlxData.value.huiFuXueJi,
  ydlxData.value.zhuanXueZhuanChu,
  ydlxData.value.zhuanXueZhuanRu,
  ydlxData.value.zhuanZhuanYe,
  ydlxData.value.zhuanBanJi,
  ydlxData.value.guoNeiFangXueHouFanXiao,
  ydlxData.value.qiTa
]
const isLevelChange = computed(() =>
  LEVEL_CHANGE_TYPES.includes(ruleForm.value.ydlb)
)
// 离校外出类异动
const LEVEL_OUT_TYPES = [
  ydlxData.value.gongPaiLiuXue,
  ydlxData.value.huiGuoFuXue,
  ydlxData.value.zhuanXueZhuanChu,
  ydlxData.value.zhuanXueZhuanRu,
  ydlxData.value.guoNeiFangXue,
  ydlxData.value.guoNeiFangXueHouFanXiao,
  ydlxData.value.qiTa
]
const isLeaveOut = computed(() =>
  LEVEL_OUT_TYPES.includes(ruleForm.value.ydlb)
)

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/jiaowu/xueshengxuejiyidongjilu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
